<template>
  <div class="guidelines-nav">
    <div class="guidelines-dots">
      <div
        class="guidelines-dot"
        :class="sections.one ? 'guidelines-dot-filled' : ''"
        @click="setNav('one')"
      ></div>
      <div
        class="guidelines-dot"
        :class="sections.two ? 'guidelines-dot-filled' : ''"
        @click="setNav('two')"
      ></div>
      <div
        class="guidelines-dot"
        :class="sections.three ? 'guidelines-dot-filled' : ''"
        @click="setNav('three')"
      ></div>
      <div
        class="guidelines-dot"
        :class="sections.four ? 'guidelines-dot-filled' : ''"
        @click="setNav('four')"
      ></div>
      <div
        class="guidelines-dot"
        :class="sections.five ? 'guidelines-dot-filled' : ''"
        @click="setNav('five')"
      ></div>
    </div>
    <div
      class="guidelines-next guidelines-back"
      @click="back"
      v-if="!sections.one"
    >
      Back
    </div>
    <div
      class="guidelines-next"
      :class="sections.one ? 'guidelines-single-btn' : ''"
      @click="next"
    >
      {{ sections.five ? `Let's go!` : "Next" }}
    </div>
  </div>
</template>

<script>
export default {
  name: "MiniGuidelinesNavigation",
  props: {
    sections: Object,
  },
  methods: {
    back() {
      this.$emit("back");
    },
    next() {
      this.$emit("next");
    },
    setNav(sectionName) {
      this.$emit("setNav", sectionName);
    },
  },
};
</script>

<style scoped>
.guidelines-nav {
  padding: calc(10px / var(--widthResoRatio));
  margin-top: calc(10px / var(--widthResoRatio));
  display: flex;
  align-items: center;
}
.guidelines-next {
  font-size: calc(20px / var(--heightResoRatio));
  letter-spacing: 0.5px;
  padding: calc(4px / var(--widthResoRatio)) calc(12px / var(--widthResoRatio));
  font-weight: 700;
  border-radius: 360px;
  cursor: pointer;
  transition: 0.1s ease;
  text-align: center;
  outline: none;
  border-color: unset;
  border: none;
  box-sizing: border-box;
  min-width: calc(85px / var(--widthResoRatio));
  margin: auto;
  font-family: "Nunito", sans-serif;
  background-color: #111;
  color: white;
  height: calc(36px / var(--heightResoRatio));
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: calc(15px / var(--widthResoRatio));
  margin-right: unset;
  box-shadow: rgb(15 15 15 / 5%) 0px 0px 0px 1px,
    rgb(15 15 15 / 10%) 0px 3px 6px, rgb(82 82 82 / 20%) 0px 9px 24px;
}
.guidelines-next:hover {
  background-color: #454545;
}
.guidelines-single-btn {
  margin-left: auto;
}
.guidelines-back {
  margin-left: auto;
  background-color: unset;
  color: black;
  box-shadow: unset;
  font-size: calc(18px / var(--heightResoRatio));
  text-decoration: underline;
  width: unset;
  min-width: unset;
  display: inline-block;
  padding: unset;
  vertical-align: middle;
  height: unset;
  margin-right: calc(15px / var(--widthResoRatio));
}
.guidelines-back:hover {
  background-color: unset;
  color: #454545;
}
.guidelines-dots {
  display: flex;
  background-color: #f5f5f5;
  border-radius: 12px;
  padding: calc(7px / var(--widthResoRatio)) 0px;
  box-shadow: rgb(209 209 209 / 5%) 0px 0px 0px 1px,
    rgb(15 15 15 / 10%) 0px 3px 6px, rgb(120 120 120 / 20%) 0px 9px 24px;
}
.guidelines-dot {
  width: calc(10px / var(--widthResoRatio));
  height: calc(10px / var(--widthResoRatio));
  border: 2px solid #222;
  box-sizing: border-box;
  border-radius: 360px;
  margin: 0px calc(8px / var(--widthResoRatio));
  cursor: pointer;
  background-color: white;
}
.guidelines-dot-filled {
  background-color: #222;
  border-color: #222;
}
</style>